import React, { createContext, ReactNode, useContext, useState } from 'react'

interface RightMostPaneContextType {
    showRightMostPane: boolean
    setShowRightMostPane: React.Dispatch<React.SetStateAction<boolean>>
}

interface RightMostPaneProviderProps {
    children: ReactNode
}

const RightMostPaneContext = createContext<
    RightMostPaneContextType | undefined
>(undefined)

export const RightMostPaneProvider = ({
    children,
}: RightMostPaneProviderProps) => {
    const [showRightMostPane, setShowRightMostPane] = useState(true)

    const value = React.useMemo(
        () => ({ showRightMostPane, setShowRightMostPane }),
        [showRightMostPane, setShowRightMostPane]
    )

    return (
        <RightMostPaneContext.Provider value={value}>
            {children}
        </RightMostPaneContext.Provider>
    )
}

export const useShowRightMostPane = (): RightMostPaneContextType => {
    const context = useContext(RightMostPaneContext)
    if (!context) {
        throw new Error(
            'useShowRightMostPane must be used within a RightMostPaneProvider'
        )
    }
    return context
}
